import { ReactComponent as SchengenIcon } from "../../../assets/images/schengen.svg";
import { ReactComponent as GCCIcon } from "../../../assets/images/gcc.svg";
import { ReactComponent as KSAIcon } from "../../../assets/images/ksa.svg";
import { ReactComponent as WorldwideIcon } from "../../../assets/images/worldwide.svg";
import { ReactComponent as WorldcupIcon } from "../../../assets/images/worldcup_white.svg";
import worldcupImg1 from "../../../assets/images/worldcup_img1.png";
import worldcupImg2 from "../../../assets/images/worldcup_img2.png";

import { config as globalConfig } from "../../../config";
const config = {
  products: [
    // {
    //   title: "worldcup.worldcup",
    //   subTitle: "worldcup.date",
    //   icon: <WorldcupIcon className="check-card-icon" />,
    //   // product code is only GC (but for functionality chanhged to GC-WC)
    //   productCode: "GC-WC",
    //   whiteListPeriods: ["ST"],
    //   cardBgImg: worldcupImg1,
    //   bodyBgImg: worldcupImg2,
    //   disableCaptcha: true,
    //   worldCup: true
    // },
    {
      title: "schengen",
      subTitle: "schengen",
      icon: <SchengenIcon className="check-card-icon" />,
      productCode: "SS",
      whiteListPeriods: ["LT", "ST"],
      limits: "limits.Limit_2",
    },
    {
      title: "gcc",
      subTitle: "gulf-cooperation-council",
      icon: <GCCIcon className="check-card-icon" />,
      productCode: "GC",
      whiteListPeriods: ["ST"],
      limits: "limits.Limit_3",
    },
    {
      title: "worldwidePlus",
      subTitle: "travel-plus-home",
      icon: <WorldwideIcon className="check-card-icon" />,
      productCode: "US",
      whiteListPeriods: ["LT", "ST"],
      limits: "limits.Limit_3",
    },
    // {
    //   title: "KSA",
    //   subTitle: "kingdom-of-saudi-arabia",
    //   icon: <KSAIcon className="check-card-icon" />,
    //   productCode: "DC",
    //   disabled: true,
    //   whiteListPeriods: ["ST"],
    // },
  ],
  banks: [
    {
      code: "55",
      nameAr: "البنك السعودي الفرنسي",
      nameEn: "Al-Bank Al-Saudi Al-Fransi",
    },
    {
      code: "05",
      nameAr: "بنك الإنماء",
      nameEn: "Al-Inma Bank",
    },
    {
      code: "80",
      nameAr: "مصرف الراجحي",
      nameEn: "Al-Rajhi Bank",
    },
    {
      code: "50",
      nameAr: "البنك الأول",
      nameEn: "Alawwal Bank",
    },
    {
      code: "30",
      nameAr: "البنك العربي الوطني",
      nameEn: "Arab National Bank",
    },
    {
      code: "98",
      nameAr: "مصرف باريس الوطني باريباس",
      nameEn: "BNP-Paribas",
    },
    {
      code: "15",
      nameAr: "بنك البلاد",
      nameEn: "Bank Al Bilad",
    },
    {
      code: "60",
      nameAr: "بنك الجزيرة",
      nameEn: "Bank Al-Jazira",
    },
    {
      code: "76",
      nameAr: "بنك مسقط",
      nameEn: "Bank Muscat",
    },
    {
      code: "81",
      nameAr: "دويتشه بنك ، الرياض",
      nameEn: "Deutsche Bank, Riyadh",
    },

    {
      code: "95",
      nameAr: "بنك الإمارات الدولي",
      nameEn: "Emirates Bank International",
    },
    {
      code: "90",
      nameAr: "بنك الخليج الدولي",
      nameEn: "Gulf International Bank",
    },

    {
      code: "71",
      nameAr: "بنك البحرين الوطني",
      nameEn: "National Bank of Bahrain",
    },
    {
      code: "75",
      nameAr: "بنك الكويت الوطني ,جدة",
      nameEn: "National Bank of Kuwait, Jeddah",
    },
    {
      code: "82",
      nameAr: "البنك الوطني الباكستاني",
      nameEn: "National Bank of Pakistan",
    },
    {
      code: "20",
      nameAr: "بنك الرياض",
      nameEn: "Riyad Bank",
    },

    {
      code: "40",
      nameAr: "بنك سامبا",
      nameEn: "Saudi American Bank",
    },
    {
      code: "01",
      nameAr: "مؤسسة النقد العربي السعودي",
      nameEn: "Saudi Arabian Monetary Agency",
    },
    {
      code: "45",
      nameAr: "بنك ساب",
      nameEn: "Saudi British Bank",
    },

    {
      code: "65",
      nameAr: "البنك السعودي للاستثمار",
      nameEn: "Saudi Investment Bank",
    },

    {
      code: "10",
      nameAr: "البنك الأهلى السعودي",
      nameEn: "Saudi National Bank",
    },
    {
      code: "83",
      nameAr: "ستيت بنك أوف إنديا ، جدة",
      nameEn: "State Bank of India, Jeddah",
    },
    {
      code: "84",
      nameAr: "البنك الزراعي لجمهورية تركيا",
      nameEn: "Turkiye Cumhuriyeti Ziraat Bankasi",
    },
  ],
  paymentSuccessRedirect: `${globalConfig.redirectDomainUrl}/travel/summary`,
  paymentFailedRedirect: `${globalConfig.redirectDomainUrl}/travel/failed`,
  sadadSuccessRedirect: `/travel/success`,
  sadadFailedRedirect: `/travel/failed`,
};

export default config;
